import { Api } from '@axiom/ui';
import type { Language } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

const api = new LegacyApiHelper('language');

export const getLanguages = async () => {
  const response = await api.GET(`${EnvUtil.apiEnvoyUrl}/languages`);
  return {
    data: response.data,
  };
};

class LanguagesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readLanguages() {
    return super.read<{ data: Language[] }>({
      endpoint: '/languages',
      method: 'GET',
    });
  }
}

export const LanguagesApi = new LanguagesApiClass();
